import { useEffect, useState } from 'react'
import MyDiv from './HrAssignementSummary.style'
import { CustomTable, CustomToast } from '../../../../components';
import { useFetch } from '../../../../hooks/useFetch';
import { Box, Flex, Grid, GridItem, Text } from '@chakra-ui/react';
import { Column } from '../../../../components/CustomTable/customTable';
import { showDate } from '../../../../utilities/helper';

export default function HrAssignementSummary() {
    const [tableData, setTableData] = useState<any[]>([]);
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);

    const loadTableData = async () => {
        const response = await fetchApi("Candidate/hr-assignment-summary", "GET");
        if (response) {
            setTableData(response);
        }
    }

    useEffect(() => {
        loadTableData();
    }, []);

    return (
        <MyDiv>
            <Box className="page_wrapper">
                <Flex className="page_heading flex_header">
                    <Text className="font-poppins text_semibold text_3xl">Hr Assignement Summary</Text>
                    <Flex className="filter_section">
                    </Flex>
                </Flex>

                <Grid className="grid_container">
                    <GridItem colSpan={12}>
                        <CustomTable value={tableData} loading={loading} emptyMessage="No found.">
                            <Column header="S.No" body={(_, index) => index + 1} />
                            <Column header="Hr Name" field='hrName' />
                            <Column header='Sequence' field='assignmentNo' />
                            <Column header='Total Assigned Candidates' field='totalAssignedCandidates' />
                            <Column header='Is Turn Pending?' field='isTurnPending' />
                            <Column header='Last Assigned At' body={(row: any) => showDate(row.lastAssignedAt)} />

                        </CustomTable>
                    </GridItem>
                </Grid>
            </Box>
        </MyDiv>
    )
}
